<template>
  <v-app>
    <v-container fluid :class="$style.appContainer">
      <div :class="$style.topLeftGradient" />
      <div :class="$style.bottomRightGradient" />
      <div style="width: 100%">
        <slot />
      </div>
    </v-container>
  </v-app>
</template>

<script setup></script>

<style lang="scss" module>
.appContainer {
  height: 100%;
  padding: 0 !important;
  background-color: #fafafa;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .banner {
    min-height: 44px;
    background-color: #1c2d3a;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0px;
    border-radius: 8px;
    width: 98%;
    z-index: 10000;
    text-align: center;
    padding: 12px;
    margin-top: 8px;

    > span {
      color: #fff;
    }

    @media only screen and (max-width: 700px) {
      min-height: 60px;

      > span {
        color: #fff;
        text-align: center;
      }
    }
  }

  .topLeftGradient {
    z-index: 1;
    position: fixed;
    top: -400px;
    left: -400px;
    width: 1000px;
    height: 1000px;
    background: rgb(217, 163, 108);
    background: radial-gradient(
      circle,
      rgba(217, 163, 108, 0.2) 10%,
      rgba(217, 163, 108, 0.1) 30%,
      rgba(250, 250, 250, 1) 64%,
      rgba(250, 250, 250, 1) 97%,
      rgba(250, 250, 250, 1) 100%
    );

    @media (max-width: $small-desktop-break-point) {
      width: 400px;
    }
  }
  .bottomRightGradient {
    z-index: 1;
    position: fixed;
    bottom: -400px;
    right: -400px;
    width: 1000px;
    height: 1000px;
    background: rgb(217, 242, 229);
    background: radial-gradient(
      circle,
      rgba(217, 242, 229, 0.3) 10%,
      rgba(217, 242, 229, 0.15) 30%,
      rgba(250, 250, 250, 1) 64%,
      rgba(250, 250, 250, 1) 97%,
      rgba(250, 250, 250, 1) 100%
    );
  }
}
</style>
